/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
/* eslint-disable no-prototype-builtins */

import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import AUbutton from '@gov.au/buttons';

const ColumnDefinitionType = PropTypes.shape({
    property: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isCommand: PropTypes.bool,
    commandLink: PropTypes.func,
    type: PropTypes.oneOf(['date', 'string']).isRequired,
    dateFormat: PropTypes.string, // if this is a date, this will be the format used by moment to parse the date
    width: PropTypes.string,
});


const SimpleTable = (props) => {
    const { caption, subcaption, columns, data } = props;


    if (props.includeEmptyRow === true && data.length === 0) {

        let defaultdata = {};

        columns.forEach(function (item) {

            defaultdata[item.property] = ' - ';
        });

        defaultdata['excludelink'] = true;

        data.push(defaultdata);
    }


    const [activeIndex, setActiveIndex] = useState(-1);
    const [sortDirection, setSortDirection] = useState(false); // true is down, false is up
    const [sortedRows, setSortedRows] = useState([...data]);

    setTimeout(() => {
        if (activeIndex === -1) {
            setSort(0);
        }
    }, 0);

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    const setSort = useCallback((index) => {
        if (index !== activeIndex) {
            setActiveIndex(index);
        }
        setSortDirection(prev => !prev);

        const propToSort = columns[index].property;
        const isDate = columns[index].type === 'date';
        const dateFormat = columns[index].dateFormat;
        const sorted = [...data].sort((a, b) => {
            if (isDate) {
                const dateA = moment(a[propToSort], dateFormat);
                const dateB = moment(b[propToSort], dateFormat);
                const before = sortDirection ? dateA.isBefore(dateB) : dateB.isBefore(dateA);
                return before ? 1 : -1

            } else {
                const before = sortDirection ? a[propToSort] < b[propToSort] : b[propToSort] < a[propToSort];
                return before ? 1 : -1
            }
        });
        setSortedRows(sorted);
    }, [activeIndex, data, columns, sortDirection]);

    const Row = (row) => {
        return (
            <tr className="au-table__row">
                {columns.map(({ property, commandLink, isCommand, type, dateFormat }, index) => {
                    const text = type === 'date' ? moment(row[property], dateFormat).format(dateFormat) : row[property];

                    if (isCommand && row.hasOwnProperty("excludelink") === false) {

                        return <td className="au-table__cell" key={index}>
                            <span>
                                <a style={{ cursor: 'pointer' }} onClick={(e) => { commandLink(row, e); }}>{text}</a>
                            </span>
                        </td>;
                    }
                    return <td className="au-table__cell" key={index}><span><span>{text}</span></span></td>
                })}
            </tr>
        );
    };

    const ColumnDef = ({ index, width, label }) => {
        if (label.length === 0) {
            return <th className="au-table__cell" width={width} />;
        }
        const chevron = (label) =>

            <span className={sortDirection ? "casa-sort-header-sorted-desc" : "casa-sort-header-sorted-asc"}>
                <a style={{ cursor: 'pointer' }} className="casa-sort-header"
                    onClick={() => setSort(index)}>
                    {label}
                </a>
            </span>

        return (
            <th className="au-table__header" width={width}>
                <div>
                    <div>
                        {activeIndex === index ? chevron(label) : <a className="casa-sort-header" style={{ cursor: 'pointer' }} onClick={() => setSort(index)}> {label} </a>}
                    </div>
                </div>
            </th>
        );
    };

    return (

        <div>
            <h4>{caption}</h4>
            <span className="au-hint-text"
                dangerouslySetInnerHTML={setInnerHTML(subcaption)}>
            </span>
        

        <table className="au-table au-table--striped casa-sort-table">
            
            <thead className="au-table__head">
                <tr className="au-table__row">
                    {columns.map((column, index) => <ColumnDef index={index} {...column} key={index} />)}
                </tr>
            </thead>
            <tbody className="au-table__body">
                {sortedRows.map((row, index) => <Row {...row} key={index} />)}
            </tbody>
            </table>
        </div>
    )
};

SimpleTable.propTypes = {
    caption: PropTypes.string.isRequired,
    subcaption: PropTypes.string,
    columns: PropTypes.arrayOf(ColumnDefinitionType).isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    includeEmptyRow: PropTypes.bool
};

export default SimpleTable;